<template>
  <card>
    <h5
      slot="header"
      class="card-title text-danger font-weight-bold"
    >
      Ticket Goals
    </h5>
    <div class="row">
      <div class="col-5" />
      <div
        class="p-0 col-2 text-center border border-white"
        style="line-height:1.2em"
        :class="statusInfo.New.badgeClass"
      >
        {{ statusInfo.New.badge }}
      </div>
      <div
        class="p-0 col-2 text-center border border-white"
        style="line-height:1.2em;"
        :class="statusInfo.InProgress.badgeClass"
      >
        {{ statusInfo.InProgress.badge }}
      </div>
      <div
        class="p-0 col-2 text-center border border-white"
        style="line-height:1.2em;"
        :class="statusInfo.Completed.badgeClass"
      >
        {{ statusInfo.Completed.badge }}
      </div>
    </div>
    <collapse>
      <collapse-item
        :name="s.Critter"
        v-for="s in statuses"
        :key="s.Critter"
      >
        <template v-slot:title>
          <div class="row">
            <div class="col-5">
              {{ s.Critter }}
            </div>
            <div class="col-2 text-center">
              {{ (s.New + s.PendingApproval) }}
            </div>
            <div class="col-2 text-center">
              {{ s.InProgress }}
            </div>
            <div class="col-2 text-center">
              {{ s.Completed }}
            </div>
          </div>
        </template>
        <div>
          <div
            class="row"
            style="font-size:10px;"
            v-for="p in peopleStatuses[s.Critter]"
            :key="p.ScouterKey"
          >
            <div class="col-5 pl-0 pr-0">
              {{ p.ScouterName }}
            </div>
            <div class="col-2 text-center">
              {{ countGoals(p, 'New') + countGoals(p, 'PendingApproval') }}
            </div>
            <div class="col-2 text-center">
              {{ countGoals(p, 'InProgress') }}
            </div>
            <div class="col-2 text-center">
              {{ countGoals(p, 'Completed') }}
            </div>
          </div>
        </div>
      </collapse-item>
    </collapse>
  </card>
</template>

<script>
import ticketStatusApi from '@/services/api/ticket-status.js'
import Collapse from '@/plugins/paper-components/collapse/collapse.vue'
import CollapseItem from '@/plugins/paper-components/collapse/collapse-item.vue'
import ticketGoalStatuses from '@/services/static/ticket-goal-statuses.js'

export default {
  name: 'HomeStaffTicketGoalStatus',
  components: {
    Collapse,
    CollapseItem
  },
  data: function () {
    return {
      statuses: [],
      statusInfo: {
        New: {},
        PendingApproval: {},
        InProgress: {},
        Completed: {}
      },
      peopleStatuses: {
        Beaver: [],
        Bobwhite: [],
        Eagle: [],
        Fox: [],
        Owl: [],
        Bear: [],
        Buffalo: [],
        Antelope: []
      }
    }
  },
  mounted () {
    ticketStatusApi.getPatrolStatus(this.$root.courseKey)
      .then(x => {
        this.statuses = x
        this.statusInfo = ticketGoalStatuses.getStatuses()
        this.getParticipants()
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    getParticipants: function () {
      ticketStatusApi.listParticipantStatus(this.$root.courseKey)
        .then(y => {
          for (var i = 0; i < y.length; i++) {
            switch (y[i].Critter) {
              case 'Beaver':
                this.peopleStatuses.Beaver.push(y[i])
                break
              case 'Bobwhite':
                this.peopleStatuses.Bobwhite.push(y[i])
                break
              case 'Eagle':
                this.peopleStatuses.Eagle.push(y[i])
                break
              case 'Fox':
                this.peopleStatuses.Fox.push(y[i])
                break
              case 'Owl':
                this.peopleStatuses.Owl.push(y[i])
                break
              case 'Bear':
                this.peopleStatuses.Bear.push(y[i])
                break
              case 'Buffalo':
                this.peopleStatuses.Buffalo.push(y[i])
                break
              case 'Antelope':
                this.peopleStatuses.Antelope.push(y[i])
                break
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    countGoals: function (personStatus, countOf) {
      var returnValue = 0
      // Yep, I know this is really inefficient, going through the object this many times.
      returnValue += (personStatus.Goal1 === countOf ? 1 : 0)
      returnValue += (personStatus.Goal2 === countOf ? 1 : 0)
      returnValue += (personStatus.Goal3 === countOf ? 1 : 0)
      returnValue += (personStatus.Goal4 === countOf ? 1 : 0)
      returnValue += (personStatus.Goal5 === countOf ? 1 : 0)

      return returnValue
    }
  }
}
</script>
